__turbopack_context__.v({
  "Actions": "index-module__AMy2nW__Actions",
  "Backdrop": "index-module__AMy2nW__Backdrop",
  "Button": "index-module__AMy2nW__Button",
  "Card": "index-module__AMy2nW__Card",
  "Cards": "index-module__AMy2nW__Cards",
  "Content": "index-module__AMy2nW__Content",
  "Description": "index-module__AMy2nW__Description",
  "DragArea": "index-module__AMy2nW__DragArea",
  "Handle": "index-module__AMy2nW__Handle",
  "Meta": "index-module__AMy2nW__Meta",
  "Popup": "index-module__AMy2nW__Popup",
  "Scroll": "index-module__AMy2nW__Scroll",
  "Title": "index-module__AMy2nW__Title",
  "Viewport": "index-module__AMy2nW__Viewport",
});
